import { render } from "./menu-component.vue?vue&type=template&id=78ef4eec&scoped=true"
import script from "./menu-component.vue?vue&type=script&lang=js"
export * from "./menu-component.vue?vue&type=script&lang=js"

import "./menu-component.vue?vue&type=style&index=0&id=78ef4eec&lang=scss&scoped=true"

import exportComponent from "E:\\projects\\resturant2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ef4eec"]])

export default __exports__